import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isLoggedIn: 'isLoggedIn',
            getAmountWatched: 'VideoPlayer/getAmountWatched',
            isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining',
            isLiveCourse: 'Courses/isLive',
            isLiveEventActive: 'Courses/isLiveEventActive',
            isCourseCompleted: 'CompletedCourses/isCourseCompleted',
            microLearningAmountWatched: 'MicroLearning/getMicroLearningCurrentWatchedPercent',
            isMicroLearningCourse: 'MicroLearning/isMicroLearningCourse',
            getUserRateForCourse: 'Ratings/getUserRateForCourse'
        }),
        enableRating () {
            const isLive = this.isLiveCourse(this.course)
            const isLiveActive = this.isLiveEventActive(this.course)
            const isDigitalTraining = this.isDigitalClassRoomTraining(this.course)
            const isCompleted = this.isCourseCompleted(this.course.id)
            const isQuarterWatched = this.isMicroLearningCourse ? this.microLearningAmountWatched > 25 : this.getAmountWatched > 0.25

            if (!this.isLoggedIn) {
                return false
            }
            return (isQuarterWatched && !isDigitalTraining) || (isLive && (isLiveActive || isCompleted))
        },
        isAllRatingDone () {
            return !Object.values(this.rating).includes(0)
        }
    }
}
